import React from "react";
import "../assets/styles/pages/experience.css";
import logoCZM from "../assets/images/logo_czm.png";
import logoTipsport from "../assets/images/logo_tipsport.svg";
import { useInView } from "react-intersection-observer";
import { useIntersectionThreshold } from "../hooks/useIntersectionThreshold";

function Experience() {
    const threshold = useIntersectionThreshold();

    const [ref1, inView1] = useInView({ threshold, triggerOnce: true });
    const [ref2, inView2] = useInView({ threshold, triggerOnce: true });
    const [ref3, inView3] = useInView({ threshold, triggerOnce: true });

    return (
        <section id="experience" className="experience section bg-raised" aria-labelledby="experience-title">
            <div className="shell">
                <header className="section__header">
                    <p className="section__eyebrow">Career</p>
                    <h2 id="experience-title" className="section__title">
                        Experience
                    </h2>
                    <p className="section__lead">
                        Backend and full-stack delivery in product teams — microservices, integrations, and tooling used
                        at scale.
                    </p>
                </header>

                <div className="card-stack">
                    <article ref={ref1} className={`timeline-card reveal${inView1 ? " is-visible" : ""}`}>
                        <div className="timeline-card__top">
                            <div className="timeline-card__brand">
                                <a
                                    className="timeline-card__logo-link"
                                    href="https://czm.fel.cvut.cz/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label="Center for Knowledge Management at CTU"
                                >
                                    <img
                                        src={logoCZM}
                                        className="timeline-card__logo img-czm-logo"
                                        alt=""
                                        height={36}
                                        width={36}
                                    />
                                </a>
                                <h3 className="timeline-card__title">Java Backend Developer · CTU CZM</h3>
                            </div>
                            <span className="timeline-card__meta">Aug 2021 – Jan 2023</span>
                        </div>
                        <div className="timeline-card__body">
                            <p>
                                Built and maintained microservices for teaching and evaluation workflows. Led work on
                                multi-stage self-evaluation flows and a PDF generation service.
                            </p>
                            <p className="timeline-card__tagline">
                                Java, Spring Boot, Spring Cloud, Spring Security, Kafka, PostgreSQL, OpenAPI, REST,
                                GraphQL · Agile &amp; Waterfall
                            </p>
                        </div>
                    </article>

                    <article ref={ref2} className={`timeline-card reveal${inView2 ? " is-visible" : ""}`}>
                        <div className="timeline-card__top">
                            <div className="timeline-card__brand">
                                <a
                                    className="timeline-card__logo-link"
                                    href="https://www.tipsport.cz/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label="Tipsport"
                                >
                                    <img
                                        src={logoTipsport}
                                        className="timeline-card__logo img-tipsport-logo"
                                        alt=""
                                        height={36}
                                    />
                                </a>
                                <h3 className="timeline-card__title">Software Engineer · Tipsport</h3>
                            </div>
                            <span className="timeline-card__meta">Mar 2023 – Present</span>
                        </div>
                        <div className="timeline-card__body">
                            <p>
                                Microservices, enterprise backend, and associated GUI — shipping features, hardening
                                services, and keeping releases predictable.
                            </p>
                            <p className="timeline-card__tagline">
                                Java EE, Spring Boot, Spring Cloud, Kafka, Redis, Oracle, PL/SQL, PostgreSQL, MongoDB,
                                REST, Swing · Agile
                            </p>
                        </div>
                    </article>

                    <article ref={ref3} className={`timeline-card reveal${inView3 ? " is-visible" : ""}`}>
                        <div className="timeline-card__top">
                            <div className="timeline-card__brand">
                                <div className="timeline-card__logo timeline-card__logo--text" aria-hidden="true">
                                    AK
                                </div>
                                <h3 className="timeline-card__title">Self-employed · Software Engineer</h3>
                            </div>
                            <span className="timeline-card__meta">Jul 2023 – Present</span>
                        </div>
                        <div className="timeline-card__body">
                            <p>
                                End-to-end delivery for clients: landing pages, SPAs, APIs, and integrations — from
                                discovery to deployment and handover.
                            </p>
                            <p className="timeline-card__tagline">
                                Java, Spring Boot, Spring Cloud, Kafka, PostgreSQL, MongoDB, REST, React, TypeScript,
                                HTML, CSS, Figma · Agile &amp; Waterfall
                            </p>
                        </div>
                    </article>
                </div>
            </div>
        </section>
    );
}

export default Experience;
